import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  return <section className="bg-brand-orange text-white py-16 px-4" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <div className="text-center mb-10" data-id="element-16">
          <motion.h2 className="text-3xl md:text-5xl font-black mb-4 drop-shadow-md" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-17">
            🧠 BONUS CLAVE{' '}
            <span className="text-xl md:text-2xl block mt-2 font-bold text-brand-cream" data-id="element-18">
              (LO QUE VENDE)
            </span>
          </motion.h2>
          <motion.p className="text-2xl md:text-3xl font-bold text-brand-darkGreen bg-brand-yellow inline-block px-6 py-2 rounded-full transform -rotate-2" initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-19">
            🧩 NO SON SOLO RECETAS
          </motion.p>
        </div>

        <motion.div className="bg-white text-brand-darkGreen rounded-2xl p-8 md:p-10 shadow-2xl" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} data-id="element-20">
          <p className="text-xl font-bold mb-6 text-brand-green" data-id="element-21">
            También incluye:
          </p>

          <div className="space-y-4 mb-8" data-id="element-22">
            {['Lista de compras lista para usar', 'Checklist semanal de organización', 'Tips para cocinar en menos tiempo', 'Ideas para freezar y reutilizar', 'Cómo armar viandas sin pensar de cero', 'Ejemplo de menú semanal'].map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-23">
                <span className="text-brand-green text-2xl font-bold" data-id="element-24">✔</span>
                <span className="text-lg md:text-xl font-medium" data-id="element-25">{item}</span>
              </div>)}
          </div>

          <div className="bg-brand-cream p-4 rounded-xl border border-brand-beige text-center" data-id="element-26">
            <p className="text-xl font-bold text-brand-orange" data-id="element-27">
              👉 Esto es lo que realmente te ahorra tiempo
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}